import React from 'react';
import 'fragments/signup-redirect/signup-redirect.scss';
import { SignupRedirectFragmentProps } from 'fragments/signup-redirect/interfaces';
import { useSignupRedirectController } from 'fragments/signup-redirect/signup-redirect.controller';
import { Button, Col, Form, Input, Row, Layout, Typography, Progress, Modal } from 'antd';
import { useTranslator } from 'tools/view-hooks/translator-hook';
const { Text, Title } = Typography;
const { Header } = Layout;

export const SignupRedirectFragment: React.FC<SignupRedirectFragmentProps> = (props) => {
    const { useController = useSignupRedirectController } = props;
    const controller = useController();
    const { translate } = useTranslator();

    // Render
    return (
        <div className={'signup-success'}>
            <Header className={'signup-success-header'}>
                <img src={'./logo-bco.png'} className={'header-img'} />
            </Header>
            <Row justify={'center'}>
                <Col flex={'600px'}>
                    <Form
                        name="basic"
                        layout={'vertical'}
                        className={'signup-success-form'}
                        initialValues={{ remember: true }}
                    >
                        <Title level={2}> {translate({ key: 'signup-redirect.title' })} </Title>
                        <Text type={'secondary'} style={{ fontSize: '14pt' }}>
                            {translate({ key: 'signup-redirect.subtitle' })}
                        </Text>

                        <Button
                            className={'button secondary'}
                            type="primary"
                            block={true}
                            // htmlType="submit"
                            loading={controller.isLoading}
                            onClick={controller.onRedirect}
                        >
                            {translate({ key: 'signup-redirect.button' })}
                        </Button>
                    </Form>
                </Col>
            </Row>
        </div>
    );
};
